import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=48a9d756&scoped=true&"
import script from "@/scripts/Setting/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Setting/index.js?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=48a9d756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9d756",
  null
  
)

export default component.exports